import React from "react";
import { Stack } from "@mui/material";
import { categories } from "../utils/constants";
import { Category } from "@mui/icons-material";

const SideBar = ({selectedCategory,setSelectedCategory}) => {
  return (
    <>
      <Stack
        direction="row"
        sx={{
          overflow: "auto",
          height: { sx: "auto", md: "95%" },
          flexDirection: { md: "column" },
        }}
      >
        {categories.map((x, key) => (
          <button
            className="category-btn"
            onClick={()=>setSelectedCategory(x.name)}
            style={{
              background: x.name === selectedCategory && "#FC1503",
              color: "#fff",
            }}
            key={key}
          >
            <span
              style={{
                color: x.name === selectedCategory ? "white" : "red",
                marginRight: "15px",
              }}
            >
              {x.icon}
            </span>
            <span style={{ opacity: x.name === selectedCategory ? "1" : "0.8" }}>
              {x.name}
            </span>
          </button>
        ))}
      </Stack>
    </>
  );
};

export default SideBar;
